module.exports = __webpack_public_path__ + "img/user.cfbd15d8.png";